import React, {useCallback, useEffect, useState} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {flexAbsoluteCenter, positionRelative} from "@pg-design/helpers-css";
import {ListIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Modal} from "@pg-design/modal-module";

import {ViewType} from "../../../../view_type/ViewType";
import {MapOfferPreview} from "../../../components/map_offer/MapOfferPreview";
import {OSMapForOffers} from "../../../components/os_map_for_offers/OSMapForOffers";
import {useOfferListMapTransportRoutes} from "../../../hooks/use_offer_list_map_transport_routes";
import {IMapOfferSidebar} from "../../../map/types/MapOfferSidebar";
import {MapSize} from "../../../views/OfferListMapView";

interface IProps {
    viewType: ViewType;
    isModalOpen: boolean;
    onModalClose: (e: React.MouseEvent | React.KeyboardEvent) => void;
    offerList: IMapOfferSidebar[];
    appliedOffers: number[];
    favouriteOffers: number[];
}

export const OfferListMapModal = (props: IProps) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const [currentOfferId, setCurrentOfferId] = useState<number | null>(null);
    const {transportRoutes} = useOfferListMapTransportRoutes();

    useEffect(() => {
        if (props.isModalOpen && !isInitialized) {
            setIsInitialized(true);
        }
    }, [props.isModalOpen]);

    // map will flicker without useCallback
    const onMarkerClick = useCallback((offerId: number) => {
        setCurrentOfferId(offerId);
    }, []);

    const onOfferSidebarClose = () => {
        setCurrentOfferId(null);
    };

    const handleSetOfferId = (offerId: number | null) => {
        setCurrentOfferId(offerId);
    };

    if (!isInitialized) {
        return (
            <div css={viewLoaderHolder}>
                <Loader />
            </div>
        );
    }

    return (
        <div css={[positionRelative]}>
            <Modal
                fullScreen
                isOpen={props.isModalOpen}
                onModalClose={props.onModalClose}
                contentStyle={{
                    display: "flex",
                    alignItems: "normal",
                    justifyContent: "normal",
                    flexDirection: "column"
                }}
            >
                {!isInitialized ? (
                    <div css={viewLoaderHolder}>
                        <Loader />
                    </div>
                ) : (
                    <div css={mapHolderSection}>
                        <Button css={mapModalButton} onClick={props.onModalClose} variant="filled_primary" iconLeft={ListIcon}>
                            Lista
                        </Button>

                        <div css={mapHolder}>
                            <MapSize fullWidth={!currentOfferId}>
                                <OSMapForOffers
                                    transportRoutes={transportRoutes}
                                    viewType={props.viewType}
                                    onMarkerClick={onMarkerClick}
                                    offers={props.offerList}
                                    favouriteOffers={props.favouriteOffers}
                                    appliedOffers={props.appliedOffers}
                                />
                            </MapSize>

                            {currentOfferId && (
                                <MapOfferPreview
                                    offerId={currentOfferId}
                                    handleSetOfferId={handleSetOfferId}
                                    onClose={onOfferSidebarClose}
                                    latestQuery={{}}
                                    isOpen={!!currentOfferId}
                                />
                            )}
                        </div>
                    </div>
                )}
            </Modal>
        </div>
    );
};

const viewLoaderHolder = css`
    ${flexAbsoluteCenter};
    height: 100vh;
`;

const mapHolderSection = css`
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;
`;

const mapHolder = css`
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
`;

const mapModalButton = css`
    position: absolute;
    top: 2.5rem;
    left: 2.5rem;
    z-index: 1;
`;
import React, {useCallback, useEffect, useState} from "react";
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {flexAbsoluteCenter, positionRelative} from "@pg-design/helpers-css";
import {ListIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {Modal} from "@pg-design/modal-module";

import {ViewType} from "../../../../view_type/ViewType";
import {MapOfferPreview} from "../../../components/map_offer/MapOfferPreview";
import {OSMapForOffers} from "../../../components/os_map_for_offers/OSMapForOffers";
import {useOfferListMapTransportRoutes} from "../../../hooks/use_offer_list_map_transport_routes";
import {IMapOfferSidebar} from "../../../map/types/MapOfferSidebar";
import {MapSize} from "../../../views/OfferListMapView";

interface IProps {
    viewType: ViewType;
    isModalOpen: boolean;
    onModalClose: (e: React.MouseEvent | React.KeyboardEvent) => void;
    offerList: IMapOfferSidebar[];
    appliedOffers: number[];
    favouriteOffers: number[];
}

export const OfferListMapModal = (props: IProps) => {
    const [isInitialized, setIsInitialized] = useState(false);
    const [currentOfferId, setCurrentOfferId] = useState<number | null>(null);
    const {transportRoutes} = useOfferListMapTransportRoutes();

    useEffect(() => {
        if (props.isModalOpen && !isInitialized) {
            setIsInitialized(true);
        }
    }, [props.isModalOpen]);

    // map will flicker without useCallback
    const onMarkerClick = useCallback((offerId: number) => {
        setCurrentOfferId(offerId);
    }, []);

    const onOfferSidebarClose = () => {
        setCurrentOfferId(null);
    };

    const handleSetOfferId = (offerId: number | null) => {
        setCurrentOfferId(offerId);
    };

    if (!isInitialized) {
        return (
            <div css={viewLoaderHolder}>
                <Loader />
            </div>
        );
    }

    return (
        <div css={[positionRelative]}>
            <Modal
                fullScreen
                isOpen={props.isModalOpen}
                onModalClose={props.onModalClose}
                contentStyle={{
                    display: "flex",
                    alignItems: "normal",
                    justifyContent: "normal",
                    flexDirection: "column"
                }}
            >
                {!isInitialized ? (
                    <div css={viewLoaderHolder}>
                        <Loader />
                    </div>
                ) : (
                    <div css={mapHolderSection}>
                        <Button css={mapModalButton} onClick={props.onModalClose} variant="filled_primary" iconLeft={ListIcon}>
                            Lista
                        </Button>

                        <div css={mapHolder}>
                            <MapSize fullWidth={!currentOfferId}>
                                <OSMapForOffers
                                    transportRoutes={transportRoutes}
                                    viewType={props.viewType}
                                    onMarkerClick={onMarkerClick}
                                    offers={props.offerList}
                                    favouriteOffers={props.favouriteOffers}
                                    appliedOffers={props.appliedOffers}
                                />
                            </MapSize>

                            {currentOfferId && (
                                <MapOfferPreview
                                    offerId={currentOfferId}
                                    handleSetOfferId={handleSetOfferId}
                                    onClose={onOfferSidebarClose}
                                    latestQuery={{}}
                                    isOpen={!!currentOfferId}
                                />
                            )}
                        </div>
                    </div>
                )}
            </Modal>
        </div>
    );
};

const viewLoaderHolder = css`
    ${flexAbsoluteCenter};
    height: 100vh;
`;

const mapHolderSection = css`
    position: relative;
    flex-grow: 1;
    flex-shrink: 1;
`;

const mapHolder = css`
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
`;

const mapModalButton = css`
    position: absolute;
    top: 2.5rem;
    left: 2.5rem;
    z-index: 1;
`;
